
export const TASK_TYPE_PICKING_ZONE = 15;
export const TASK_TYPE_PICKING = 16;
export const TASK_TYPE_CHECKING = 17;
export const TASK_TYPE_MISSING = 18;

